<template>
        <div class="card-text">
            <b-row>
                <b-col cols="6">
                    <app-form-text-input placeholder="Nombre" v-model="filters.name" />
                </b-col>
                <b-col cols="6">
                    <b-button variant="primary" @click="$emit('filter', filters)">
                        <i class="fa fa-filter"></i>
                    </b-button>
                    <b-button variant="secondary" @click="clearFilters">
                        <i class="fa fa-times-circle"></i>
                    </b-button>
                </b-col>
            </b-row>
        </div>
</template>
<script>
export default {
    data() {
        return {
            filters: {
                name: '',
            },
        }
    },
    methods: {
        clearFilters() {
            Object.keys(this.filters).map(key => (this.filters[key] = ''))
            this.$emit('filter', null)
        },
    },
}
</script>


